import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { NAVIGATION } from '../../data/constants';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMenu, FiX } = FiIcons;

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  return (
    <header className={`fixed top-0 w-full z-[1000] transition-all duration-500 h-[60px] md:h-[68px] flex items-center ${
      isScrolled ? 'bg-[#050506]/90 backdrop-blur-md border-b border-[#242832]' : 'bg-[#050506] border-b border-transparent'
    }`}>
      <div className="max-w-[1200px] mx-auto w-full px-6 lg:px-8 flex justify-between items-center gap-8">
        <Link to="/" className="text-lg font-bold tracking-tighter text-[#F7F8FA] shrink-0">
          MAXMARK<span className="text-[#2F6BFF]">.</span>
        </Link>

        <nav className="hidden xl:flex items-center space-x-7">
          {NAVIGATION.map((item) => (
            <Link
              key={item.name}
              to={item.href}
              className={`text-[12px] font-medium tracking-[0.08em] uppercase transition-colors ${
                location.pathname === item.href ? 'text-[#2F6BFF]' : 'text-[#A7ADB8] hover:text-[#F7F8FA]'
              }`}
            >
              {item.name}
            </Link>
          ))}
        </nav>

        <div className="hidden xl:flex items-center gap-5 shrink-0">
          <Link
            to="/login"
            className="text-[12px] font-semibold text-[#A7ADB8] hover:text-[#F7F8FA] transition-colors"
          >
            Client Portal
          </Link>
          <Link
            to="/request-review"
            className="bg-[#2F6BFF] hover:bg-[#1a54ff] text-white px-4 py-2 rounded-lg text-[12px] font-semibold transition-all active:scale-95"
          >
            Request Review
          </Link>
        </div>

        <button
          className="xl:hidden text-[#F7F8FA] p-2 -mr-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <SafeIcon icon={mobileMenuOpen ? FiX : FiMenu} className="w-5 h-5" />
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="xl:hidden fixed inset-0 top-[60px] bg-[#050506] z-[999] p-8 flex flex-col"
          >
            <div className="space-y-8">
              {NAVIGATION.map((item) => (
                <Link 
                  key={item.name} 
                  to={item.href} 
                  className="block text-2xl font-semibold text-[#F7F8FA]"
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contact" className="block text-2xl font-semibold text-[#F7F8FA]">Contact</Link>
              <Link to="/login" className="block text-2xl font-semibold text-[#F7F8FA]">Client Portal</Link>
            </div>
            <div className="mt-auto">
              <Link to="/request-review" className="block w-full bg-[#2F6BFF] text-white text-center py-5 rounded-xl font-bold uppercase tracking-widest text-xs">
                Request Review
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}